import { Component, OnInit } from '@angular/core';

import { SharedRankingListService } from 'src/app/@theme/components/shared-ranking-list/shared-ranking-list.service';

import * as Constants from 'src/app/core/constants';

@Component({
    selector: 'app-youth-ranking',
    templateUrl: './youth-ranking.component.html',
    styleUrls: ['./youth-ranking.component.scss'],
})
export class YouthRankingComponent implements OnInit {
    /**
     * Definição da identificão da sessão/depto Juvenil
     */
    constants = Constants;
    public departmentType: string = this.constants.DEPARTMENT_TYPE_YOUTH;
    public pathRoute: string = this.constants.DEPARTMENT_PATH_YOUTH;

    constructor(private rankingListService: SharedRankingListService) {}

    ngOnInit(): void {}
}
